import React from "react";
import { useDispatch } from "react-redux";
import { notification } from "../../utils/Notifications.tsx";
import { deleteMissingBox } from "../../services/missing-box-partner.service.ts";
import { toCamelCase } from "../../hooks/toCameCase.tsx";

interface DeleteMissingBoxModalProps {
  closeFn: () => void;
  record: any;
  onSuccess: () => void;
}

const DeleteMissingBoxModal = ({ closeFn, record, onSuccess }: DeleteMissingBoxModalProps) => {
  const dispatch = useDispatch();

  const removeRecord = async () => {
    try {
      await deleteMissingBox(record.id);
      onSuccess();
      closeFn();
      notification("Eliminado", "Faltante en caja eliminado correctamente", "success");
    } catch (error: any) {
      console.error("Error al eliminar:", error);
      notification("Error", error?.message || "No se pudo eliminar el faltante en caja", "danger");
    }
  };

  const partnerName = record?.partner?.person
    ? toCamelCase(
        `${record.partner.person.firstName || ""} ${
          record.partner.person.lastName || ""
        } ${record.partner.person.secondLastName || ""}`
      )
    : "Colaborador";

  return (
    <React.Fragment>
      <p className="fs-15px">
        ¿Estás seguro de que deseas eliminar el faltante en caja de {partnerName}?
      </p>
      <p className="fs-14px text-muted">
        Esta acción no se puede deshacer.
      </p>
      <div className="d-flex justify-content-end">
        <button className="btn btn-secondary me-2" onClick={() => closeFn()}>
          Cancelar
        </button>
        <button className="btn btn-danger" onClick={() => removeRecord()}>
          Eliminar
        </button>
      </div>
    </React.Fragment>
  );
};

export default DeleteMissingBoxModal;
